export const defaultColumnWidth = 80;
export const modalWidth = 1000;
export const rowHeight = 50;
export const tableHeight = 308;
export const modalFooterHeight = 90;
export const modalFooterShimHeight = 30;
export const searchBarHeight = 38;
export const headerHeight = 39;
export const progressBarSpacer = 2;
export const contentWidth = 890;

export const COLUMN_IDS = {
    DETECTION_HISTORY: 'detection_history',
    DETECTION_START: 'detection_start',
    DURATION: 'duration',
    ENABLED: 'enabled',
    SELECTION: 'selection',
    TITLE: 'title',
    UPLOAD_DATE: 'uploadDate',
};
